import { authApi } from 'api';

/**
 * Retrieves the program for a specific meet if it exists.
 * @param {string} meetId - The ID of the meet
 * @returns {Promise} - The response from the API containing meet program.
 */
export const getMeetProgram = async (meetId) => {
  return await authApi.get(`/meets/${meetId}/program`);
};

/**
 * Creates a new meet program or completely replaces an existing one.
 * @param {string} meetId - The ID of the meet
 * @param {object} data - An object containing the updated meet program
 * @returns {Promise} - A Promise that resolves to the API response after updating the program.
 */
export const updateMeetProgram = async (meetId, data) => {
  return await authApi.post(`/meets/${meetId}/program`, data);
};

/**
 * delete a meet program
 * @param {string} meetId - The ID of the meet
 * @param {object|null} resolutions - Optional Impact Review resolutions; required
 *   (via a 409 round-trip) when the delete orphans volunteers/start lists/registrations.
 * @returns {Promise} - A Promise that resolves to the API response after deleting the program.
 */
export const deleteMeetProgram = async (meetId, resolutions = null) => {
  return await authApi.delete(
    `/meets/${meetId}/program`,
    resolutions ? { data: resolutions } : undefined
  );
};

// Get complete meet details including event program and volunteer requirements in a single call
export const getMeetComplete = async (clubId, meetId) => {
  return await authApi.get(`/Meets/${clubId}/${meetId}/complete-details`);
};
